export const STRAIGHT_LENGTH = 290;
export const CURVE_RADIUS = 66;
export const FINISH_STRAIGHT = 450;
export const TRACK_LENGTH = STRAIGHT_LENGTH + Math.PI * CURVE_RADIUS + FINISH_STRAIGHT;
export const STARTING_GRID = Object.freeze([
  { distance: 0, lane: -4.3 }, { distance: -.7, lane: 4.3 },
  { distance: -7.5, lane: -4.3 }, { distance: -8.2, lane: 4.3 },
  { distance: -15, lane: 0 },
].map(slot => Object.freeze(slot)));

export function trackPose(distance, lane = 0) {
  if (distance <= STRAIGHT_LENGTH) return { x: lane, y: 0, z: distance, heading: 0 };
  const curveDistance = distance - STRAIGHT_LENGTH;
  if (curveDistance < Math.PI * CURVE_RADIUS) {
    const heading = curveDistance / CURVE_RADIUS;
    return {
      x: CURVE_RADIUS * (1 - Math.cos(heading)) + lane * Math.cos(heading),
      y: 0,
      z: STRAIGHT_LENGTH + CURVE_RADIUS * Math.sin(heading) - lane * Math.sin(heading),
      heading,
    };
  }
  return { x: CURVE_RADIUS * 2 - lane, y: 0, z: STRAIGHT_LENGTH - (curveDistance - Math.PI * CURVE_RADIUS), heading: Math.PI };
}
